import { makeStyles } from '@material-ui/core';

import { ItemStatus } from 'features/EntityDetails/components/EntityDetails/ChipListDetail/utils/ChipListDetailUtils';

type Props = {
  itemStatus?: ItemStatus;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  header: {
    marginRight: theme.spacing(0.5),
    width: '160px',
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    justifyContent: 'left',
    alignItems: 'center',
  },
  chip: (props: Props) => ({
    margin: theme.spacing(0.2),
    backgroundColor: {
      [ItemStatus.NEW]: undefined,
      [ItemStatus.ADDED]: theme.palette.green[100],
      [ItemStatus.REMOVED]: theme.palette.red[100],
      [ItemStatus.UNCHANGED]: undefined,
    }[props.itemStatus!],
    color: {
      [ItemStatus.NEW]: undefined,
      [ItemStatus.ADDED]: theme.palette.success.dark,
      [ItemStatus.REMOVED]: theme.palette.error.dark,
      [ItemStatus.UNCHANGED]: undefined,
    }[props.itemStatus!],
    textDecoration: props.itemStatus === ItemStatus.REMOVED ? 'line-through' : 'none',
  }),
}));

export default useStyles;
